<template>
  <img v-if="thumbnail && imgLoaded" :src="thumbnail" :alt="name">
  <svg-icon v-else-if="typeIcon" :icon="typeIcon" :cls="typeCls"></svg-icon>
  <space-icon v-else :space="space"></space-icon>
</template>

<script>
import SvgIcon from './SvgIcon'
import SpaceIcon from './SpaceIcon'

export default {
  name: 'ThumbIcon',
  components: {
    SvgIcon,
    SpaceIcon
  },
  props: {
    name: String,
    thumbnail: String,
    typeIcon: [String, Boolean],
    space: String,
    typeCls: {
      type: String,
      default: 'type-icon'
    }
  },
  data () {
    return {
      imgLoaded: false
    }
  },
  created () {
    if (this.thumbnail) {
      this.loadImg(this.thumbnail)
    }
  },
  watch: {
    thumbnail (val) {
      if (val) {
        this.loadImg(val)
      }
    }
  },
  methods: {
    loadImg (url) {
      this.removeImg()

      this.img = document.createElement('img')
      this.img.setAttribute('style', 'display: none')
      this.img.onload = () => {
        this.imgLoaded = true
        this.removeImg()
      }
      this.img.onerror = this.removeImg

      document.body.appendChild(this.img)
      this.img.src = url
    },
    removeImg () {
      if (this.img && document.body.contains(this.img)) document.body.removeChild(this.img)
    }
  }
}
</script>
